export default __webpack_public_path__ + "static/lina-9e695a635dc1356646bf22ce7f4f9aa9.jpg";